module.exports = __webpack_public_path__ + "static/media/logo.d38fe9ae.svg";